import styled from 'styled-components'

export const ToastContainer = styled.div`
	position: fixed;
	top: 10px;
	left: 50%;
	transform: translateX(-50%);
	transition: 500ms;
	background: white;
	color: white;
	padding: 15px;
	border-radius: 5px;
	border: 1px solid black;
	z-index: 10000;
	width: 300px;
	text-align: center;
`

export const ToastHeader = styled.div`
	font-size: 18px;
	font-weight: bold;
	margin-bottom: 10px;
`

export const ToastMessage = styled.div`
	font-size: 16px;
	margin-bottom: 15px;
`

export const ButtonContainer = styled.div`
	display: flex;
	justify-content: center;
	gap: 10px;
`

export const ToastButton = styled.button`
	background-color: #007bff;
	color: white;
	border: none;
	padding: 8px 16px;
	border-radius: 5px;
	cursor: pointer;
	font-size: 14px;
`
